shadow$provide[303] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, View:{enumerable:true, get:function() {
  return View;
}}});
var require$_DOT__DOT__SLASH_transform_SLASH_transform_DOT_js = require("../transform/transform.js");
class View extends require$_DOT__DOT__SLASH_transform_SLASH_transform_DOT_js.Transform {
  static initClass() {
    this.traits = ["node", "object", "visible", "view", "vertex"];
  }
  make() {
    return this._helpers.visible.make();
  }
  unmake() {
    return this._helpers.visible.unmake();
  }
  axis(dimension) {
    return this.props.range[dimension - 1];
  }
}
View.initClass();

};